// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "static-assets/js/" + "main" + "." + "6521f66b" + ".js"; };